module.exports = __webpack_public_path__ + "static/potential-62cf5966b591eddc0963f07d72082133.jpg";